"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockMoistureLoad = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.lockMoistureLoad = (0, graphql_tag_1.default) `
  mutation LockMoistureLoad($moistureLoadId: ID!) {
    lockMoistureLoad(moistureLoadId: $moistureLoadId) {
      id
    }
  }
`;
//# sourceMappingURL=lock-moisture-load.js.map